import {Injectable} from '@angular/core';
import {RestangularModule, Restangular} from 'ngx-restangular';

@Injectable()
export class ApprovalMasterService {

    constructor(private restangular: Restangular) {
    }

    getAllApprovals() {
        return this.restangular.all('getAllApprovals');
    }

    approveDocument() {
        return this.restangular.all('approveDocument');
    }

    rejectDocument() {
        return this.restangular.all('rejectDocument');
    }

    getAllApprovalDelegations() {
        return this.restangular.all('getAllApprovalDelegations');
    }

  getAllApprovalDelegationsAdminView() {
        return this.restangular.all('getAllApprovalDelegationsAdminView');
    }

    approvalDelegationsCRUD() {
        return this.restangular.all('approvalDelegationsCRUD');
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/approval-master.service.ts